import { Code as CodeIcon, Notes as NotesIcon } from "@mui/icons-material";

import { AppTopBarList } from "@moment/design-system/AppTopBarList";
import { Toolbar } from "@moment/design-system/Toolbar";
import { ToolbarItem } from "@moment/design-system/ToolbarItem";

import { BackButton } from "~/components/topbar/BackButton";
import { TopBar } from "~/components/topbar/TopBar";
import { useIsFeatureFlagEnabled } from "~/state";
import { Flag } from "~/state/types";

export const DocumentTopBar = ({
	view = "rich",
	onViewChange = () => {},
}: {
	view?: "rich" | "markdown";
	onViewChange?: (view: "rich" | "markdown") => void;
} = {}) => {
	const isDisplayMarkdownEditorEnabled = useIsFeatureFlagEnabled(Flag.DisplayMarkdownEditor);

	return (
		<TopBar>
			{/* left side */}
			<AppTopBarList>
				<BackButton />
				{isDisplayMarkdownEditorEnabled && (
					<Toolbar>
						<ToolbarItem
							isActive={view === "rich"}
							onClick={() => onViewChange("rich")}
							label="Rich text"
						>
							<NotesIcon />
						</ToolbarItem>
						<ToolbarItem
							isActive={view === "markdown"}
							onClick={() => onViewChange("markdown")}
							label="Markdown"
						>
							<CodeIcon />
						</ToolbarItem>
					</Toolbar>
				)}
			</AppTopBarList>
		</TopBar>
	);
};
